import styled from 'styled-components'

import ActionButton from '../ActionButton'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.greyf5};
  padding: 7rem 2rem 7rem 2rem;
  position: relative;
`

export const BackButton = styled(ActionButton)`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndexes.header - 10};
  top: 5%;
  left: 5%;
`

export const SadFace = styled.div`
  ${({ theme }) => theme.textStyles.titleH1_36};
  font-size: 13rem;
`

export const Text = styled.div`
  ${({ theme }) => theme.textStyles.titleH2_23};
  font-size: 2.6rem;
`
